import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        error: {
            redirectButtonText: string;
        };
    };
};

export const messagesDE: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    DOCTOR: 'Doktor/In',
    NURSE: 'Krankenschwester',
    OTHER_HEALTH_WORKER: 'Anderes Gesundheitspersonal',
    step: {
        personalInfo: {
            howDoesVerifyingWorkDetails: 'Um für dieses Angebot in Frage zu kommen, müssen Sie (1) ein derzeit lizenzierter medizinischer Fachmann sein und\n (2) einem berechtigten Zweig des medizinischen Berufs angehören. Die in Frage kommenden Zweige werden im Auswahlfeld Status\n dieses Formulars angezeigt.<br><br>{companyName} verwendet SheerID, einen vertrauenswürdigen Partner, um zu überprüfen, ob Sie eine medizinische Fachkraft sind.\n SheerID sammelt nur Informationen, die bei der Überprüfung Ihrer Anspruchsberechtigung hilfreich sind.\n Zusätzliche Informationen oder Unterlagen können angefordert werden. ',
        },
        success: {
            verificationOnly: "SheerID kümmert sich nur um die Verifizierung. Jetzt, da Sie genehmigt worden sind, richten Sie bitte alle Fragen zu den Werbebedingungen und/oder zur Verwendung des Codes an den Customer Service von <a href='https://www.timberland.co.uk/customer-service/contact-us.html?geoRedirect=true' target=_blank class='sid-link' >Timberland</a>.",
        },
        error: {
            redirectButtonText: 'WEITER ZU TIMBERLAND',
        },
    },
};
